import { useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useGetServiceById } from '../../../apis/services/get-service-by-id';
import { useCancelService } from '../../../apis/services/cancel-service';
const useServiceDetails = () => {
    const { id } = useParams<{ id: string }>();
    const [selectedServiceId, setSelectedServiceId] = useState("");

    const { data: serviceInfo, isLoading: loading, refetch } = useGetServiceById(id!);
    const { mutateAsync: cancelService, isPending: isCancellingService } = useCancelService();

    const handleServiceCancel = async () => {
        try {
            await cancelService(selectedServiceId);
            toast.success("Service Cancelled Successfully");
            refetch();
        } catch (error) {
            toast.error("Couldn't cancel service at this moment. Please try again later.");
        } finally {
            setSelectedServiceId("");
        }
    };

    const isMapVisible = useMemo(() => {
        return (
            serviceInfo?.serviceMeta?.deliveryLocation?.lng &&
            serviceInfo?.serviceMeta?.deliveryLocation?.lat &&
            serviceInfo?.serviceMeta?.pickupLocation?.lat &&
            serviceInfo?.serviceMeta?.pickupLocation?.lng
        );
    }, [serviceInfo]);

    return {
        id,
        serviceInfo,
        loading,
        isCancellingService,
        selectedServiceId,
        setSelectedServiceId,
        handleServiceCancel,
        isMapVisible,
    };
};

export default useServiceDetails;